import { Box, SxProps, Theme } from '@mui/material';
import React, { useMemo } from 'react';

import { CARD_MIN_WIDTH } from '../../../constants/ui';

interface IProps<T> {
  items: T[];
  renderItem: (item: T) => React.ReactNode;
  getItemKey: (item: T) => string | number;
  footerItem?: React.ReactNode;
  minItemWidth?: number;
  columns?: string | Record<string, string>;
  gap?: number | Record<string, number>;
}

export function GridView<T>({
  items,
  renderItem,
  getItemKey,
  footerItem,
  minItemWidth = CARD_MIN_WIDTH,
  columns,
  gap,
}: IProps<T>) {
  const gridSx: SxProps<Theme> = useMemo(
    () => ({
      display: 'grid',
      gridTemplateColumns: columns ?? `repeat(auto-fill, minmax(min(${minItemWidth}px, 100%), 1fr))`,
      ...(gap ? { gap } : { rowGap: 2, columnGap: 3 }),
      justifyContent: 'flex-start',
      alignItems: 'stretch',
    }),
    [columns, minItemWidth, gap],
  );

  return (
    <Box sx={gridSx}>
      {items?.map((item) => (
        <React.Fragment key={getItemKey(item)}>{renderItem(item)}</React.Fragment>
      ))}
      {footerItem}
    </Box>
  );
}
